<template>
  <b-modal
    v-if="isShowDetails"
    id="modal-detail"
    ref="modal-detail"
    title="收據明細"
    title-class="text-primary"
    header-class="border-bottom-0"
    footer-class="justify-content-center"
    scrollable
    ok-only
    ok-title="關閉"
    ok-variant="action"
    size="xl"
  >
    <details-page v-bind="$props" :detailData="detailData"></details-page>
  </b-modal>
</template>

<script>
export default {
  name: 'DetailModal',

  inheritAttrs: false,

  props: {
    // 繳款人歸戶資訊 btn 開關
    isPayerBtn: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      detailData: [],
      preReceipt: false,
      isShowDetails: false, // 是否開啟視窗
    };
  },

  computed: {
    totalRows() {
      return this.resultData.length;
    },
  },

  methods: {
    getDetailData(item) {
      console.log(item);
      this.detailData = item;
      console.log('getDetailData:', this.detailData)
      this.isShowDetails = true;
      this.$nextTick(() => {
        this.$bvModal.show('modal-detail');
      });
      // this.$refs['modal-detail'].show();
    },
    applyToMe(rowData) {
      // eslint-disable-next-line no-alert
      window.alert(`歸戶明細：${JSON.stringify(rowData)}`);
    },
    previewReceipt(rowData) {
      // eslint-disable-next-line no-alert
      window.alert(`預覽發票：${JSON.stringify(rowData)}`);
    },
  },
};
</script>
